import { render, staticRenderFns } from "./ComplaintSuggestions.vue?vue&type=template&id=282a778f&"
import script from "./ComplaintSuggestions.vue?vue&type=script&lang=js&"
export * from "./ComplaintSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports